module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACASURBVEiJ3ZVBDoAgDASJL+dnPG09eCBGabvbkhj37M7QYkJrvwmAjis9wRhLBu4ZCTgAwP2Akbx0nxOoErrDFOSpI8XMSl1AGm6ByuCGpA7uSELwo+QEmWxd0dZLtkBpSQQgS5giLVFOFe5gPjj0XkMSFb6SWBPI/zYKnt3v5QQfb5MBLmqjnAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close.png
// module id = q6r7
// module chunks = 0